import { EventCard } from './EventCard';
import { RegistrationForm } from './RegistrationForm';
import { TrustIndicators } from './TrustIndicators';
import React from 'react';
import { Container, Row, Col, Card, Button, Form, Badge } from "react-bootstrap";


export default function SignupHero({
  beTheFooter = false,

  // non-card content
  title,
  subtitle,

  // cards (data-instanced upstream)
  cards = []
}) {
  const heroStyle = {
    // backgroundImage: 'url("/images/hero-bg.jpg")',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    position: 'relative',
    // color: '#fff'
  };
  const overlayStyle = {
    position: 'absolute',
    top: 0, left: 0, right: 0, bottom: 0,
    // backgroundColor: 'rgba(224, 247, 250,1)'
  };
  const contentStyle = {
    position: 'relative',
    zIndex: 1,
    paddingTop: '0rem',
    paddingBottom: '4rem'
  };

  const handleFormSubmit = async (e) => {};

  return (
    <section style={heroStyle}>
      <div style={overlayStyle} />
      <Container style={contentStyle}>
        <Row>
          <Col md={12}>
            {(!beTheFooter || beTheFooter == false) && (
              <div>
                {/* <Badge
                  bg="warning"
                  text="dark"
                  className="mb-3 text-uppercase"
                >
                  2-Days of Creative Workshops
                </Badge> */}
                <h1 className="display-4">{title || 'AI for Creatives'}</h1>
                <p className="lead">
                  {subtitle || 'Learn how to deepen and widen your creative process'}
                </p>
              </div>
            )}
            <br/><br/>
            <Row  className="g-3 justify-content-end">
              {cards.map((card, idx) => {
                if (card.render_control_type === 'event_card') {
                  return (
                    <Col key={idx} md={4}>
                      <EventCard
                        header={card.title}
                        buttonLabel={card.actionLabel}
                        date={card.date}
                        time={card.time || ''}
                        location={card.location}
                        detailsLink={card.actionHref}
                      />
                    </Col>
                  );
                }

                if (card.render_control_type === 'registration_form') {
                  return (
                    <Col key={idx} md={4}>
                      <RegistrationForm
                        title={card.formTitle}
                        subtitle={card.formSubtitle}
                        onSubmit={handleFormSubmit}
                      />
                    </Col>
                  );
                }

                return null;
              })}
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  );
}